import ComponentInit from './utils/ComponentInit';
import SitecoreSearchBlock from '../sections/sitecore-search-block/s-sitecore-search-block';

// Format:
// data-component-name: ComponentFunction
// we shall order these in page load critical first
const componentList = { SitecoreSearchBlock };

export default ComponentInit(componentList);
